import React, { useEffect } from "react";
import { Box, Stack, Typography, Divider } from "@mui/material";
import { useNavigationHistory } from "../context/NavigationHistoryContext";

/**
 * Página de inicio del sistema - DESKTOP ONLY
 * Página simple de bienvenida con diseño formal y elegante
 *
 * REGLAS APLICADAS:
 * - Solo <Stack> para layout
 * - Componentes con size="small"
 * - Tema MásXPieza aplicado
 * - NINGÚN código responsive
 * - Diseño minimalista y profesional
 */
export function HomePage(): React.ReactElement {
  const { pushToHistory } = useNavigationHistory();

  // Registrar entrada en historial al montar (limpiar historial en inicio)
  useEffect(() => {
    pushToHistory("/", "Inicio");
  }, [pushToHistory]);

  return (
    <Stack
      spacing={0}
      sx={{
        minHeight: "60vh",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          width: "100%",
          px: 4,
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontWeight: 300,
            letterSpacing: "-0.5px",
            color: "text.primary",
            mb: 2,
          }}
        >
          Bienvenido a VillApps
        </Typography>

        <Divider
          sx={{
            width: 200,
            mx: "auto",
            mb: 3,
            borderColor: "primary.main",
            borderWidth: 1,
          }}
        />

        <Typography
          variant="h5"
          sx={{
            fontWeight: 400,
            color: "text.secondary",
            letterSpacing: "0.5px",
          }}
        >
          Sistema de gestión integral de Mas X Pieza
        </Typography>
      </Box>
    </Stack>
  );
}
